export default __webpack_public_path__ + "static/media/image 4 (1).e2daf84f.png";